module.exports = __webpack_public_path__ + "static/img/son5.7e6e30f1.png";